import { setAuth, setProfile } from "../reducers/authReducer";
import { setConfig } from "../reducers/configReducer";
import axios from "axios";
import getError from "../utils/getError";
import setAuthToken from "../utils/setAuthToken";
import url from "../utils/url";
import { isPermitted } from "../utils/PermissionManager";
import { masterFunction } from "../api/api";

export const loginAdmin = (data, loginAfterFunction) => (dispatch) => {
  axios
    .post(url + "/auth", data)
    .then((res) => {
      let resData = masterFunction(res, ".data");
      if (resData && resData.success) {
        const access_token =
          resData.access_token || resData.result?.access_token;

        axios
          .get(url + "/profile", {
            headers: {
              Authorization: `Bearer ${access_token}`,
            },
          })
          .then((res) => {
            let profile = masterFunction(res, ".result");
            let roles = profile?.roles ? profile?.roles : [];
            if (isPermitted(roles, ["super_admin"])) {
              let deviceInfo = null;
              if (window.deviceInfo) {
                deviceInfo = { ...window.deviceInfo };
              }
              setAuthToken(access_token, deviceInfo);
              localStorage.setItem("skyadminrep", access_token);
              dispatch(setAuth(true));
              dispatch(saveConfig());
              loginAfterFunction(true);
            } else {
              loginAfterFunction(false, "You are not authorized");
            }
          })
          .catch((err) => {
            loginAfterFunction(false, getError(err));
          });
      } else {
        loginAfterFunction(false, resData?.message || "Invalid OTP");
      }
    })
    .catch((err) => {
      loginAfterFunction(false, getError(err));
    });
};

export const saveConfig = () => (dispatch) => {
  axios
    .get(url + "/config")
    .then((res) => {
      let config = masterFunction(res, ".result");
      if (config) {
        localStorage.setItem("config", JSON.stringify(config));
        dispatch(setConfig(config));
        dispatch(setProfile(config?.profile));
      }
    })
    .catch((err) => {});
};
export const saveProfile = () => (dispatch) => {
  axios
    .get(url + "/profile")
    .then((res) => {
      let profile = masterFunction(res, ".result");
      if (profile) {
        let role = profile?.role ? profile?.role : "";
        dispatch(setProfile(profile));
      }
    })
    .catch((err) => {});
};

export const logoutAdmin = (afterFunction) => (dispatch) => {
  axios
    .delete(url + "/auth")
    .then((res) => {})
    .catch((err) => {});
  localStorage.removeItem("skyadminrep");
  localStorage.removeItem("config");
  setAuthToken(null);
  dispatch(setAuth(false));
  dispatch(setProfile(null));
  dispatch(setConfig(null));
  afterFunction(true);
};

export const setAdmin = (isAuthenticated) => (dispatch) => {
  dispatch(setAuth(isAuthenticated));
};
export const setAdminProfile = (data) => {
  return {
    type: "SET_ADMIN_PROFILE",
    payload: data,
  };
};

export const setAdminRole = (data) => {
  return {
    type: "SET_ADMIN_ROLES",
    payload: data,
  };
};
